
let pdfjsLib;
let shadowCanvas;

setTimeout(()=>{
    if(typeof document !== 'undefined'){
        import('pdfjs-dist/build/pdf.mjs').then((mod) => {
            pdfjsLib = mod
        })
        shadowCanvas = document.createElement('canvas');
    }
}, 450)



export async function convertPdfToImageFromFileInput(files:FileList) {
    return new Promise((resolve, reject)=>{
        let reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = async () => {
            const preview = await convertPdfToImage(reader.result, 'blob');
            resolve(preview);
        }
    });

}
export default async function convertPdfToImage(dataUrl: URL, format: 'dataurl' | 'blob' = 'dataurl') {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs';
    const context = shadowCanvas.getContext('2d');

    const task = pdfjsLib.getDocument(dataUrl);
    const pdf = await task.promise;


    const responseArray: string[]|Blob[] = []
    for(let i = 0; i < pdf.numPages; i++) {
        const page = await pdf.getPage(i + 1);
        const viewport = page.getViewport({scale: 1.5});
        shadowCanvas.height = viewport.height;
        shadowCanvas.width = viewport.width;
        const renderContext = {
            canvasContext: context,
            transform: null,
            viewport: viewport
        };
        await page.render(renderContext).promise;
        if(format === 'blob') {
            responseArray.push(await new Promise((resolve) => {
                shadowCanvas.toBlob((blob)=>{
                    resolve(blob)
                },'image/png');
            }))

        }
        responseArray.push(shadowCanvas.toDataURL());
    }
    return responseArray;
    /*const page = await pdf.getPage(1);
    const viewport = page.getViewport({scale: 1.5});
    shadowCanvas.height = viewport.height;
    shadowCanvas.width = viewport.width;
    const renderContext = {
        canvasContext: context,
        transform: null,
        viewport: viewport
    };
    await page.render(renderContext).promise;
    if(format === 'blob') {
        return await new Promise((resolve) => {
            shadowCanvas.toBlob((blob)=>{
                resolve(blob)
            },'image/png');
        })

    }
    return shadowCanvas.toDataURL();*/
}